import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PrizetBulkUpload } from "../../../components/PrizetBulkUpload";
import { API } from "../../../config/config";
import React from "react";

interface ProductBulkUploadDialogProps {
  open: boolean,
  toggleVisibility: (value: boolean) => void,
}

export const ProductsBulkUploadDialog = ({ open, toggleVisibility }: ProductBulkUploadDialogProps) => {
  return (
    <Dialog maxWidth={"md"} fullWidth={true} open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Bulk Upload
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={(e) => toggleVisibility(false) }
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <PrizetBulkUpload url={`${API.HOST}/api/v1/products/bulk-upload`} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled={false} autoFocus onClick={(e) => {
        }}>
          {<CircularProgress size={6} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
